import CircularProgress from '@mui/material/CircularProgress';
import { Box, BoxProps } from '@mui/material';

// reusable loader component which takes entire parent space and show
// loader in middle
type LoaderProps = BoxProps & {
  loaderColor?: string;
  loaderSize?: string;
};

const Loader = ({ loaderColor, loaderSize, ...props }: LoaderProps) => (
  <Box
    {...props}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flex: '1',
    }}
  >
    <CircularProgress size={loaderSize} sx={{ color: loaderColor }} />
  </Box>
);

export default Loader;
